export default __webpack_public_path__ + "static/media/watch-mobile1.464c33ba.png";